<div class="alert alert-information">
    <img src="assets/icons/infoOutlined.svg" />
    <div class="text-info"> {{message}} </div>
</div>